module.exports = __webpack_public_path__ + "media/images/reset_youreveryday_logo-9c185855.png";